import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { taskStatusLabels, taskTypeLabels } from './constants';
import { Task } from './types';
import { useSearchParams } from 'react-router';
import { Params } from '@/utils/types';

const taskTypeOptions = [
	{ key: 'All', value: 'All' },
	...Object.entries(taskTypeLabels).map(([key, value]) => ({ key, value }))
];

const taskStatusOptions = [
	{ key: 'All', value: 'All' },
	...Object.entries(taskStatusLabels).map(([key, value]) => ({ key, value }))
];

type TasksFiltersProps = {
	handleMgIdChange: (mgId: string) => void;
	handleTaskTypeChange: (type: Task['type']) => void;
	handleTaskStatusChange: (status: Task['status']) => void;
};

const TasksFilters = (props: TasksFiltersProps) => {
	const { handleMgIdChange, handleTaskStatusChange, handleTaskTypeChange } = props;
	const [searchParams] = useSearchParams();
	return (
		<div className="flex flex-col gap-1 lg:gap-5 lg:flex-row">
			<div className="flex flex-col gap-2 min-w-2xs">
				<Label htmlFor="mgId" className="text-sm">
					Measurement Group ID
				</Label>
				<Input
					type="number"
					id="mgId"
					defaultValue={searchParams.get(Params.mgId) || ''}
					onChange={event => handleMgIdChange(event.target.value)}
					className="w-full"
					placeholder="Search by ID"
					aria-label="Search"
				/>
			</div>

			<div className="flex flex-col gap-2 min-w-2xs">
				<Label htmlFor="taskType" className="text-sm">
					Task type
				</Label>
				<Select value={searchParams.get(Params.type) || 'All'} onValueChange={handleTaskTypeChange}>
					<SelectTrigger className="w-full" aria-label="Task type" id="taskType">
						<SelectValue placeholder="Task type" />
					</SelectTrigger>
					<SelectContent>
						{taskTypeOptions.map(option => (
							<SelectItem key={option.key} value={option.key}>
								{option.value}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>

			<div className="flex flex-col gap-2 min-w-2xs">
				<Label htmlFor="taskstatus" className="text-sm">
					Task status
				</Label>
				<Select value={searchParams.get(Params.status) || 'All'} onValueChange={handleTaskStatusChange}>
					<SelectTrigger className="w-full" aria-label="Task status" id="taskstatus">
						<SelectValue placeholder="Task status" />
					</SelectTrigger>
					<SelectContent>
						{taskStatusOptions.map(option => (
							<SelectItem key={option.key} value={option.key}>
								{option.value}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>
		</div>
	);
};

export default TasksFilters;
